import BaseView from './BaseView';
let view = null;

import { ScrollTrigger } from "gsap/ScrollTrigger";

class Culture extends BaseView {
	constructor(container) {
		super(container);
	}

	init() {

		this.header = this.container.querySelector('[data-culture-header]');
		if(this.header) {
			ScrollTrigger.create({
				trigger: this.header,
				start: "top top",
				end: document.documentElement.scrollHeight,
				pin: this.header,
				pinSpacing: false
			});
		}

	}
}

export default {
	namespace: 'template-culture',
	beforeEnter: ({ current, next, trigger }) => {
		view = new Culture(next.container);
		view.init();
	},
	afterLeave: ({ current, next, trigger }) => {
		view.destroy();
		view = null;
	},
};
